<template lang="pug">
div
  div(class='map' ref='map')
  v-dialog(v-model='dialog.open' max-width='800px')
    v-card
      v-card-title
        span(class='headline') {{ dialog.title }}
      v-container(grid-list-xl)
        v-layout(wrap)
          v-flex(xs6)
            v-checkbox(
              v-model='model.published'
              label='Метка опубликована'
              color='primary'
            )  
          v-flex(xs6)
            v-checkbox(
              v-model='model.authorized_only'
              label='Только для авторизованных'
              color='primary'
            )  
          v-flex(xs6)
            v-text-field(
              :error='errors.has("name")'
              :error-messages='errors.first("name")'
              v-model='model.name'
              label='Название'
            )
          v-flex(xs6)
            v-text-field(
              :error='errors.has("slug")'
              :error-messages='errors.first("slug")'
              v-model='model.slug'
              label='Slug для указания в URL (транслит)'
            )          
          v-flex(xs4)
            s-genplan-mark-types-picker(
              :complexId='id'
              :error='errors.has("mark_type_id")'
              :error-messages='errors.first("mark_type_id")'
              v-model='model.mark_type_id'
            )
          v-flex(xs4)
            v-select(
              :items=[
                {"value":"genplan","text":"Метка"},
                {"value":"floor_view","text":"Вид с этажа"}
              ]
              v-model='model.type'
              label='Тип метки'
            )
          v-flex(xs4)
            v-select(
              :disabled='model.type!="floor_view"'
              :items=[
                {"value":null,"text":"Не указан"},
                {"value":"video","text":"Видео"},
                {"value":"pano","text":"Панорама"}
              ]
              v-model='model.sub_type'
              label='Тип контента (опционально)'
            )                     
          v-flex(xs6)
            v-text-field(
              :disabled='model.type!="floor_view"'
              v-model='model.floor_number'
              label='Номер этажа для "Вид с этажа"'
            )            
          v-flex(xs6)
            v-text-field(
              :disabled='model.type!="floor_view"'
              v-model='model.floor_name'
              label='Название этажа (опционально)'
            )
          v-flex(xs12)
            v-text-field(
              :error='errors.has("link")'
              :error-messages='errors.first("link")'
              v-model='model.link'
              label='Ссылка для перехода'
            )                                                
          v-flex(xs12)
            v-textarea(
              :error='errors.has("html")'
              :error-messages='errors.first("html")'
              v-model='model.html'
              label='HTML'
              no-resize
            )
          v-flex(xs12)
            v-text-field(
              :disabled='true'
              :error='errors.has("poly_genplan")'
              :error-messages='errors.first("poly_genplan")'
              v-model='model.poly_genplan'
              label='Координаты'
            )            
          v-flex(sm6)
            s-image-upload(
              :src='model.picture_url'
              :error='errors.has("picture")'
              :error-messages='errors.first("picture")'
              v-model='model.picture'
              :aspect-ratio='16/9'
              label='Картинка'
            )            
      v-card-actions
        template(v-if='model.id')
          v-btn(flat @click="removePlacemark(model)") Удалить
        v-spacer
        v-btn(flat @click="closeDialog") Отмена
        v-btn(color="primary" flat @click="upsertPlacemark(model)") Сохранить
</template>

<script>
import http from '@/http'
import get from 'lodash/get'

import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

import 'leaflet.fullscreen'
import 'leaflet.fullscreen/Control.FullScreen.css'

const getInitialModel = () => ({
  name: null,
  poly_genplan: null,
  mark_type_id: null,
  html: null,
  published: true
})

const createIcon = props => {
  return L.icon({
    iconUrl: props.icon_url,
    iconSize: [+props.width, +props.height],
    iconAnchor: [+props.offcet_x, +props.offcet_y]
  })
}

export default {
  props: ['id', 'object', 'active'],

  data: () => ({
    placemarks: [],
    leafletPlacemarks: {},
    model: getInitialModel(),
    dialog: { title: null, open: false }
  }),

  mounted() {
    this.fetchPlacemarks()
    clearTimeout(this.timer)
    this.timer = setTimeout(this.createMap)
  },

  methods: {
    upsertPlacemark(placemark) {
      if (placemark.id) this.updatePlacemark(placemark)
      else this.createPlacemark(placemark)
    },

    async createPlacemark(placemark) {
      try {
        await http.post(`/complexes/${this.id}/marks`, placemark)
        this.fetchPlacemarks()
        this.closeDialog()
      } catch (error) {
        this.$root.showSnack('Ошибка создания метки')
      }
    },

    async updatePlacemark(placemark) {
      try {
        await http.patch(`/complexes/${this.id}/marks/${placemark.id}`, placemark)
        this.fetchPlacemarks()
        this.closeDialog()
      } catch (error) {
        this.$root.showSnack('Ошибка обновления метки')
      }
    },

    async removePlacemark(placemark) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await http.delete(`/complexes/${this.id}/marks/${placemark.id}`)
          this.fetchPlacemarks()
          this.closeDialog()
        } catch (error) {
          this.$root.showSnack('Ошибка удаления метки')
        }
      }
    },

    async fetchPlacemarks() {
      try {
        const response = await http.get(`/complexes/${this.id}/marks`)
        this.placemarks = response.data
      } catch (error) {
        this.$root.showSnack('Ошибка загрузки')
      }
    },

    createMap() {
      if (!this.genplan) return
      if (this.map) this.removeMap()

      const { width, height, minZoom, url, mask } = this.genplan
      const dimensions = [width, height]

      this.map = L.map(this.$refs.map, {
        attributionControl: false,
        fullscreenControl: true
      })

      const rc = new L.RasterCoords(this.map, dimensions)

      this.map.setMaxZoom(rc.zoomLevel())
      this.map.setMinZoom(minZoom)

      this.map.setView(rc.unproject([dimensions[0] / 2, dimensions[1] / 2]), minZoom)

      L.tileLayer(url + mask, { noWrap: true }).addTo(this.map)

      this.map.on('click', ev => {
        L.DomEvent.stopPropagation(ev)
        this.onMapClick(ev)
      })

      this.renderPlacemarks()
    },

    removeMap() {
      this.map.remove()
      this.map = null
    },

    onMapClick(ev) {
      const coordinates = this.map.mouseEventToLatLng(ev.originalEvent)
      const geoJSON = this.convertToJSON(coordinates)

      this.openDialog('Создание метки')
      this.model.poly_genplan = geoJSON
    },

    closeDialog() {
      this.flushModel()
      this.dialog.open = false
      this.dialog.title = null
    },

    openDialog(title) {
      this.flushModel()
      this.dialog.open = true
      this.dialog.title = title
    },

    flushModel() {
      this.model = getInitialModel()
    },

    convertToJSON(coordinates) {
      return JSON.stringify({
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [
            coordinates.lng,
            coordinates.lat,
          ]
        }
      })
    },

    renderPlacemarks() {
      Object.values(this.leafletPlacemarks).forEach(placemark => placemark.remove())

      for (let placemark of this.placemarks) {
        try {
          const icon = createIcon(placemark.mark_type)
          const coordinates = JSON.parse(placemark.poly_genplan).geometry.coordinates.reverse()
          const marker = L.marker(coordinates, { icon, draggable: true })

          marker.on('click', () => {
            this.openDialog('Редактирование маркера')
            this.model = placemark
          })

          marker.on('dragend', async () => {
            setTimeout(async () => {
              if (await this.$confirm('Изменить локацию маркера?')) {
                const coordinates = marker.getLatLng()

                this.model = placemark
                this.model.poly_genplan = this.convertToJSON(coordinates)

                this.upsertPlacemark(this.model)
              } else {
                marker.setLatLng(coordinates)
              }
            })
          })

          marker.addTo(this.map)
          this.leafletPlacemarks[placemark.id] = marker
        } catch (error) {
          this.$root.showSnack('Ошибка парсинга: ' + JSON.stringify(error))
        }
      }
    }
  },

  computed: {
    genplan() {
      return get(this.object, 'complex_settings.genplan')
    }
  },

  watch: {
    genplan() {
      clearTimeout(this.timer)
      this.timer = setTimeout(this.createMap)
    },

    placemarks() {
      if (this.map) {
        this.renderPlacemarks()
      }
    },

    active() {
      setTimeout(() => this.map.invalidateSize(), 100)
    }
  }
}
</script>

<style scoped>
.map {
  z-index: 1;
  height: 600px;
  overflow: hidden;
  position: relative;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}
</style>